import React from 'react';

import { CardHeaderRow } from 'containers/UserDetails/components/UserJobInformation/styles';

import { Card, CardBody, CardHeaderActions, CardTitle } from './styles';

export interface SettingsCardProps {
  title: React.ReactNode;
  /** Sits at the right of the header row, such as a close button. */
  action?: React.ReactNode;
  as?: 'aside';
  'aria-label'?: string;
  'data-testid'?: string;
  children: React.ReactNode;
}

const SettingsCard: React.FunctionComponent<SettingsCardProps> = ({ title, action, as, children, ...rest }) => (
  <Card as={as} aria-label={rest['aria-label']} data-testid={rest['data-testid']}>
    <CardHeaderRow>
      <CardTitle>{title}</CardTitle>
      {action ? <CardHeaderActions>{action}</CardHeaderActions> : null}
    </CardHeaderRow>
    <CardBody>{children}</CardBody>
  </Card>
);

export default SettingsCard;
